'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Drawer = require('./Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Drawer2.default;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/Drawer/index.js
 ** module id = 887
 ** module chunks = 3
 **/